module.exports = __webpack_public_path__ + "img/OM.44246af9.svg";